import { render, staticRenderFns } from "./smartSingleElectionac.vue?vue&type=template&id=8f8e5bd0&scoped=true&"
import script from "./smartSingleElectionac.vue?vue&type=script&lang=js&"
export * from "./smartSingleElectionac.vue?vue&type=script&lang=js&"
import style0 from "./smartSingleElectionac.vue?vue&type=style&index=0&id=8f8e5bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8e5bd0",
  null
  
)

export default component.exports